module.exports = __webpack_public_path__ + "static/media/si-LK.c0c0fd80.md";